import { GsFormSchema } from '../../../components/gs-form/interfaces/gs-form-schema';
import { ACTIVE_SCHEMA_FIELDS, PICTURE_DISPLAY_MODE_SCHEMA } from '../basics';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/** Form schema for the Promotions component settings in the designer. */
export const PROMOTIONS_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...PICTURE_DISPLAY_MODE_SCHEMA,
    // Only "pageSize" has an effect: the layout is fixed to two columns and load-more pagination.
    {
      formControlName: 'pageSize',
      label: 'schema.items.pageSize',
      type: 'number',
      default: 12,
      min: 1,
      groupingName: 'schema.items.name'
    },
    {
      formControlName: 'buttons',
      label: 'components.promotions.schema.buttons',
      type: 'group',
      expandable: true,
      default: {},
      fields: buttonSchemaFields()
    }
  ]
};
